<template>
  <div class="widget-inner py-12 px-16 expand-icon">
    <div
      v-if="activeObject"
      class="accordion-collapse">
      <div
        class="animation-panel position-relative"
        @click.stop>
        <h3 class="clr-3F3F3F pl-15 pr-15 fs-12 mb-12 mt-15 fw-600 font-size-weight">Basic</h3>
        <div class="animation-row">
          <div :class="{active: activeSubPanel === 'stomp', selected: currentObjAnimeStyle === 'stomp'}">
            <img
              src="@/assets/images/stomp.png"
              @click.stop="showSubpanel('stomp', {style: 'stomp', onEnter: true, onExit: false})">
            <h5>Stomp</h5>
          </div>
          <div
            :class="{active: activeSubPanel == 'pan', selected: currentObjAnimeStyle == 'panbottom' || currentObjAnimeStyle == 'pantop' || currentObjAnimeStyle == 'panleft' || currentObjAnimeStyle == 'panright'}">
            <img
              src="@/assets/images/pan.png"
              @click.stop="showSubpanel('pan', {style: 'panright', onEnter: true, onExit: false})">
            <h5>Pan</h5>
          </div>
          <div :class="{active: activeSubPanel == 'fade', selected: currentObjAnimeStyle == 'fade'}">
            <img
              src="@/assets/images/fade.png"
              @click.stop="showSubpanel('fade', {style: 'fade', onEnter: true, onExit: false})">
            <h5>Fade</h5>
          </div>
        </div>
        <div
          v-if="activeSubPanel == 'stomp'"
          class="animation-subpanel">
          <div>
            <h5 class="clr-3F3F3F fs-12">Animate</h5>
            <button
              :class="{ selected: onEnterAnimate && onExitAnimate }"
              @click.stop="handleAnimation({style: 'stomp', onEnter: true, onExit: true})">Both
            </button>
            <button
              :class="{ selected: onEnterAnimate && !onExitAnimate }"
              @click.stop="handleAnimation({style: 'stomp', onEnter: true, onExit: false})">On Enter
            </button>
            <button
              :class="{ selected: !onEnterAnimate && onExitAnimate }"
              @click.stop="handleAnimation({style: 'stomp', onEnter: false, onExit: true})">On Exit
            </button>
          </div>
          <div class="mt-30">
            <h5 class="clr-3F3F3F fs-12">Speed</h5>
            <input
              id="range-slider__range1"
              v-model="speed"
              type="range"
              class="range__input"
              min="1"
              max="100"
              @click.stop
              @mouseup="handleAnimation({style: currentObjAnimeStyle, onEnter: onEnterAnimate, onExit: onExitAnimate})"
            >
          </div>
        </div>
        <div
          v-if="activeSubPanel == 'pan'"
          class="animation-subpanel">
          <div>
            <h5 class="clr-3F3F3F fs-12">Animate</h5>
            <button
              :class="{ selected: onEnterAnimate && onExitAnimate }"
              @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: true})">Both
            </button>
            <button
              :class="{ selected: onEnterAnimate && !onExitAnimate }"
              @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: false})">On Enter
            </button>
            <button
              :class="{ selected: !onEnterAnimate && onExitAnimate }"
              @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: false, onExit: true})">On Exit
            </button>
          </div>
          <div class="mt-30">
            <h5 class="clr-3F3F3F fs-12">Speed</h5>
            <input
              id="range-slider__range9"
              v-model="speed"
              type="range"
              class="range__input"
              min="1"
              max="100"
              @click.stop
              @mouseup="handleAnimation({style: currentObjAnimeStyle, onEnter: onEnterAnimate, onExit: onExitAnimate})"
            >
          </div>
          <div class="mt-30">
            <h5 class="clr-3F3F3F fs-12">Distance</h5>
            <input
              id="range-slider__distance"
              v-model="distance"
              type="range"
              class="range__input"
              min="1"
              max="100"
              @click.stop
              @mouseup="handleAnimation({style: currentObjAnimeStyle, onEnter: onEnterAnimate, onExit: onExitAnimate})"
            >
          </div>
          <div class="mt-30">
            <h5 class="clr-3F3F3F fs-12">Direction</h5>
            <button
              :class="{ selected: currentObjAnimeStyle == 'panleft' }"
              @click.stop="handleAnimation({style: 'panleft', onEnter: onEnterAnimate, onExit: onExitAnimate})">
              <img src="@/assets/images/left-direction.png">
            </button>
            <button
              :class="{ selected: currentObjAnimeStyle == 'panright' }"
              @click.stop="handleAnimation({style: 'panright', onEnter: onEnterAnimate, onExit: onExitAnimate})">
              <img src="@/assets/images/right-direction.png">
            </button>
            <button
              :class="{ selected: currentObjAnimeStyle == 'pantop' }"
              @click.stop="handleAnimation({style: 'pantop', onEnter: onEnterAnimate, onExit: onExitAnimate})">
              <img src="@/assets/images/bottom-direction.png">
            </button>
            <button
              :class="{ selected: currentObjAnimeStyle == 'panbottom' }"
              @click.stop="handleAnimation({style: 'panbottom', onEnter: onEnterAnimate, onExit: onExitAnimate})">
              <img src="@/assets/images/top-direction.png">
            </button>
          </div>
        </div>
        <div
          v-if="activeSubPanel == 'fade'"
          class="animation-subpanel">
          <div>
            <h5 class="clr-3F3F3F fs-12">Animate</h5>
            <button
              :class="{ selected: onEnterAnimate && onExitAnimate }"
              @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: true})">Both
            </button>
            <button
              :class="{ selected: onEnterAnimate && !onExitAnimate }"
              @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: false})">In
            </button>
            <button
              :class="{ selected: !onEnterAnimate && onExitAnimate }"
              @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: false, onExit: true})">Out
            </button>
          </div>
          <div class="mt-30">
            <h5 class="clr-3F3F3F fs-12">Speed</h5>
            <input
              id="range-slider__range3"
              v-model="speed"
              type="range"
              class="range__input"
              min="1"
              max="100"
              @click.stop
              @mouseup="handleAnimation({style: currentObjAnimeStyle, onEnter: onEnterAnimate, onExit: onExitAnimate})"
            >
          </div>
        </div>
        <div class="animation-row mt-13">
          <div
            :class="{active: activeSubPanel == 'zoom',selected: currentObjAnimeStyle == 'zoomin' || currentObjAnimeStyle == 'zoomout'}">
            <img
              src="@/assets/images/zoom.png"
              @click.stop="showSubpanel('zoom', {style: 'zoomin', onEnter: true, onExit: false})">
            <h5>Zoom</h5>
          </div>
        </div>
        <div
          v-if="activeSubPanel == 'zoom'"
          class="animation-subpanel">
          <div>
            <h5 class="clr-3F3F3F fs-12">Animate</h5>
            <button
              :class="{ selected: onEnterAnimate && onExitAnimate }"
              @click.stop="handleAnimation({style: 'zoomin', onEnter: true, onExit: true})">Both
            </button>
            <button
              :class="{ selected: onEnterAnimate && !onExitAnimate }"
              @click.stop="handleAnimation({style: 'zoomin', onEnter: true, onExit: false})">On Enter
            </button>
            <button
              :class="{ selected: !onEnterAnimate && onExitAnimate }"
              @click.stop="handleAnimation({style: 'zoomin', onEnter: false, onExit: true})">On Exit
            </button>
          </div>
          <div class="mt-30">
            <h5 class="clr-3F3F3F fs-12">Scale Speed</h5>
            <input
              id="range-slider__range4"
              v-model="speed"
              type="range"
              class="range__input"
              min="1"
              max="100"
              @click.stop
              @mouseup="handleAnimation({style: currentObjAnimeStyle, onEnter: onEnterAnimate, onExit: onExitAnimate})"
            >
          </div>
          <!-- <div class="mt-20">
            <h5 class="clr-3F3F3F fs-12">Scale</h5>
            <button
              :class="{selected: currentObjAnimeStyle == 'zoomin'}"
              @click.stop="handleAnimation({style: 'zoomin', onEnter: onEnterAnimate, onExit: onExitAnimate})">In
            </button>
            <button
              :class="{selected: currentObjAnimeStyle == 'zoomout'}"
              @click.stop="handleAnimation({style: 'zoomout', onEnter: onEnterAnimate, onExit: onExitAnimate})">Out
            </button>
          </div> -->
        </div>
        <div
          v-show="isActiveObjectIsText"
          class="clr-3F3F3F pl-15 pr-15 fs-12 mb-12 mt-15 fw-600 font-size-weight">Text
          Animation
        </div>
        <div class="animation-row mt-13">
          <div
            v-show="isActiveObjectIsText"
            :class="{active: currentObjAnimeStyle === 'typewriter',selected: currentObjAnimeStyle == 'typewriter'}">
            <img
              src="@/assets/images/zoom.png"
              @click.stop="showSubpanel('typewriter', {style: 'typewriter', onEnter: true, onExit: false})">
            <h5>Typewriter</h5>
          </div>
          <div
            v-show="isActiveObjectIsText"
            :class="{active: currentObjAnimeStyle === 'burst',selected: currentObjAnimeStyle == 'burst' || currentObjAnimeStyle == 'burst'}">
            <!-- <span class="position-absolute coming-soon">Coming Soon</span> -->
            <img
              src="@/assets/images/zoom.png"
              @click.stop="showSubpanel('burst', {style: 'burst', onEnter: true, onExit: false})">
            <h5>Burst</h5>
          </div>
        </div>
        <div
          v-show="currentObjAnimeStyle == 'typewriter'"
          class="animation-subpanel typewritersubpanel">
          <div>
            <h5 class="clr-3F3F3F fs-12">Animate</h5>
            <button
              :class="{selected: currentObjAnimeStyle == 'typewriter' && onEnterAnimate && onExitAnimate}"
              @click.stop="handleAnimation({style: 'typewriter', onEnter: true, onExit: true})">
              Both
            </button>
            <button
              :class="{selected: currentObjAnimeStyle == 'typewriter' && onEnterAnimate && !onExitAnimate}"
              @click.stop="handleAnimation({style: 'typewriter', onEnter: true, onExit: false})">On
              Enter
            </button>
            <button
              :class="{selected: currentObjAnimeStyle == 'typewriter' && !onEnterAnimate && onExitAnimate}"
              @click.stop="handleAnimation({style: 'typewriter', onEnter: false, onExit: true})">On
              Exit
            </button>
          </div>
          <div class="mt-30">
            <h5 class="clr-3F3F3F fs-12">Speed</h5>
            <input
              id="range-slider__range6"
              v-model="speed"
              type="range"
              class="range__input"
              min="1"
              max="100"
              @click.stop
              @mouseup="handleAnimation({style: 'typewriter', onEnter: onEnterAnimate, onExit: onExitAnimate})"
            >
          </div>
        </div>
        <div
          v-show="currentObjAnimeStyle === 'burst'"
          class="animation-subpanel">
          <div>
            <h5 class="clr-3F3F3F fs-12">Animate</h5>
            <button
              :class="{selected: currentObjAnimeStyle == 'burst' && onEnterAnimate && onExitAnimate }"
              @click.stop="handleAnimation({style: 'burst', onEnter: true, onExit: true})">Both
            </button>
            <button
              :class="{selected: currentObjAnimeStyle == 'burst' && onEnterAnimate && !onExitAnimate}"
              @click.stop="handleAnimation({style: 'burst', onEnter: true, onExit: false})">On Enter
            </button>
            <button
              :class="{selected: currentObjAnimeStyle == 'burst' && !onEnterAnimate && onExitAnimate}"
              @click.stop="handleAnimation({style: 'burst', onEnter: false, onExit: true})">On Exit
            </button>
          </div>
          <div class="mt-30">
            <h5 class="clr-3F3F3F fs-12">Speed</h5>
            <input
              id="range-slider__range6"
              v-model="speed"
              type="range"
              class="range__input"
              min="1"
              max="100"
              @click.stop
              @mouseup="handleAnimation({style: 'burst', onEnter: onEnterAnimate, onExit: onExitAnimate})"
            >
          </div>
        </div>
        <div
          v-show="isActiveObjectIsImage"
          class="clr-3F3F3F pl-15 pr-15 fs-12 mb-12 mt-15 fw-600 font-size-weight">
          Photo Movement
        </div>
        <div
          v-show="isActiveObjectIsImage"
          class="animation-row">
          <div
            :class="{active: activeSubPanel === 'photoZom', selected: currentObjAnimeStyle === 'photoZomEnterOut' || currentObjAnimeStyle === 'photoZomEnterIn'}">
            <img
              src="@/assets/images/stomp.png"
              @click.stop="showSubpanel('photoZom', {style: 'photoZomEnterOut', onEnter: true, onExit: false})">
            <h5>Photo Zoom</h5>
          </div>
          <div
            :class="{active: activeSubPanel === 'photoRise', selected: currentObjAnimeStyle === 'photoRiseTop' || currentObjAnimeStyle == 'photoRiseLeft' || currentObjAnimeStyle == 'photoRiseRight' || currentObjAnimeStyle == 'photoRiseBottom'}">
            <img
              src="@/assets/images/stomp.png"
              @click.stop="showSubpanel('photoRise', {style: 'photoRiseTop', onEnter: true, onExit: false})">
            <h5>Photo Pan</h5>
          </div>
        </div>
        <div
          v-if="activeSubPanel == 'photoZom'"
          class="animation-subpanel">
          <div>
            <h5 class="clr-3F3F3F fs-12">Animate</h5>
            <button
              :class="{ selected: onEnterAnimate && onExitAnimate }"
              @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: true})">Both
            </button>
            <button
              :class="{ selected: onEnterAnimate && !onExitAnimate }"
              @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: false})">On Enter
            </button>
            <button
              :class="{ selected: !onEnterAnimate && onExitAnimate }"
              @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: false, onExit: true})">On Exit
            </button>
          </div>
          <div class="mt-30">
            <h5 class="clr-3F3F3F fs-12">Speed</h5>
            <input
              id="range-slider__range5"
              v-model="speed"
              type="range"
              class="range__input"
              min="1"
              max="100"
              @click.stop
              @mouseup="handleAnimation({style: currentObjAnimeStyle, onEnter: onEnterAnimate, onExit: onExitAnimate})"
            >
          </div>
          <div class="mt-20">
            <h5 class="clr-3F3F3F fs-12">Scale</h5>
            <button
              :class="{selected: currentObjAnimeStyle == 'photoZomEnterIn'}"
              @click.stop="handleAnimation({style: 'photoZomEnterIn', onEnter: onEnterAnimate, onExit: onExitAnimate})">In
            </button>
            <button
              :class="{selected: currentObjAnimeStyle == 'photoZomEnterOut'}"
              @click.stop="handleAnimation({style: 'photoZomEnterOut', onEnter: onEnterAnimate, onExit: onExitAnimate})">Out
            </button>
          </div>
        </div>
        <div
          v-if="activeSubPanel == 'photoRise'"
          class="animation-subpanel">
          <div>
            <h5 class="clr-3F3F3F fs-12">Animate</h5>
            <button
              :class="{ selected: onEnterAnimate && onExitAnimate }"
              @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: true})">Both
            </button>
            <button
              :class="{ selected: onEnterAnimate && !onExitAnimate }"
              @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: true, onExit: false})">On Enter
            </button>
            <button
              :class="{ selected: !onEnterAnimate && onExitAnimate }"
              @click.stop="handleAnimation({style: currentObjAnimeStyle, onEnter: false, onExit: true})">On Exit
            </button>
          </div>
          <div class="mt-30">
            <h5 class="clr-3F3F3F fs-12">Speed</h5>
            <input
              id="range-slider__range2"
              v-model="speed"
              type="range"
              class="range__input"
              min="1"
              max="100"
              @click.stop
              @mouseup="handleAnimation({style: currentObjAnimeStyle, onEnter: onEnterAnimate, onExit: onExitAnimate})"
            >
          </div>
          <div class="mt-30">
            <h5 class="clr-3F3F3F fs-12">Direction</h5>
            <button
              :class="{ selected: currentObjAnimeStyle == 'photoRiseLeft' }"
              @click.stop="handleAnimation({style: 'photoRiseLeft', onEnter: onEnterAnimate, onExit: onExitAnimate})">
              <img src="@/assets/images/left-direction.png">
            </button>
            <button
              :class="{ selected: currentObjAnimeStyle == 'photoRiseRight' }"
              @click.stop="handleAnimation({style: 'photoRiseRight', onEnter: onEnterAnimate, onExit: onExitAnimate})">
              <img src="@/assets/images/right-direction.png">
            </button>
            <button
              :class="{ selected: currentObjAnimeStyle == 'photoRiseTop' }"
              @click.stop="handleAnimation({style: 'photoRiseTop', onEnter: onEnterAnimate, onExit: onExitAnimate})">
              <img src="@/assets/images/bottom-direction.png">
            </button>
            <button
              :class="{ selected: currentObjAnimeStyle == 'photoRiseBottom' }"
              @click.stop="handleAnimation({style: 'photoRiseBottom', onEnter: onEnterAnimate, onExit: onExitAnimate})">
              <img src="@/assets/images/top-direction.png">
            </button>
          </div>
        </div>
        <div
          v-show="isActiveObjectHasAnimation"
          class="animation-row remove-container">
          <button
            class="remove_animation"
            @click.stop="removeAnimation">
            Remove Animation
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="togglePageAnimation && !activeObject"
      class="accordion-collapse">
      <div
        class="animation-panel position-relative transitions"
        @click.stop>
        <h3 class="clr-3F3F3F pl-15 pr-15 fs-12 mb-12 mt-15 fw-600 font-size-weight">Page Transition</h3>
        <div class="animation-row">
          <div
            :class="{active: selectedTransition.name == 'transitionNone', selected: selectedTransition.name == 'transitionNone'}"
            class="none">
            <img
              src="@/assets/images/tnone.webp"
              @click.stop="showPageAnimationSubPanel({style: 'transitionNone'})">
            <h5>None</h5>
          </div>
          <div :class="{active: selectedTransition.name == 'transitionFade', selected: selectedTransition.name == 'transitionFade'}">
            <img
              src="@/assets/images/fade.png"
              @click.stop="showPageAnimationSubPanel({style: 'transitionFade'})">
            <h5>Fade</h5>
          </div>
          <div
            :class="{active: selectedTransition.name.includes('transitionPan'), selected: selectedTransition.name.includes('transitionPanLeft')}">
            <img
              src="@/assets/images/pan.png"
              @click.stop="showPageAnimationSubPanel({style: 'transitionPanLeft'})">
            <h5>Pan</h5>
          </div>
        </div>
        <div
          v-if="selectedTransition.name == 'transitionFade'"
          class="animation-subpanel">
          <div class="">
            <h5 class="clr-3F3F3F fs-12">Duration</h5>
            <input
              id="range-slider__range3"
              v-model="speed"
              type="range"
              class="range__input"
              min="1"
              max="100"
              @click.stop
              @mouseup="showPageAnimationSubPanel({style: 'transitionFade'})"
            >
          </div>
        </div>
        <div
          v-if="selectedTransition.name.includes('transitionPan')"
          class="animation-subpanel">
          <div class="">
            <h5 class="clr-3F3F3F fs-12">Duration</h5>
            <input
              id="range-slider__range9"
              v-model="speed"
              type="range"
              class="range__input"
              min="1"
              max="100"
              @click.stop
              @mouseup="showPageAnimationSubPanel({style: selectedTransition.name})"
            >
          </div>
          <div class="mt-30">
            <h5 class="clr-3F3F3F fs-12">Direction</h5>
            <button
              :class="{ selected: selectedTransition.name == 'transitionPanLeft' }"
              @click.stop="showPageAnimationSubPanel({style: 'transitionPanLeft'})">
              <img src="@/assets/images/left-direction.png">
            </button>
            <button
              :class="{ selected: selectedTransition.name == 'transitionPanRight' }"
              @click.stop="showPageAnimationSubPanel({style: 'transitionPanRight'})">
              <img src="@/assets/images/right-direction.png">
            </button>
            <button
              :class="{ selected: selectedTransition.name == 'transitionPanTop' }"
              @click.stop="showPageAnimationSubPanel({style: 'transitionPanTop'})">
              <img src="@/assets/images/bottom-direction.png">
            </button>
            <button
              :class="{ selected: selectedTransition.name == 'transitionPanBottom' }"
              @click.stop="showPageAnimationSubPanel({style: 'transitionPanBottom'})">
              <img src="@/assets/images/top-direction.png">
            </button>
          </div>
        </div>
        <div
          v-if="currentAnimation.style.includes('pageZoom')"
          class="animation-subpanel">
          <div>
            <h5 class="clr-3F3F3F fs-12">Animate</h5>
            <button
              :class="{ selected: onEnterAnimate && onExitAnimate }"
              @click.stop="updatePageAnimation({style: currentAnimation.style, onEnter: true, onExit: true})">Both
            </button>
            <button
              :class="{ selected: onEnterAnimate && !onExitAnimate }"
              @click.stop="updatePageAnimation({style: currentAnimation.style, onEnter: true, onExit: false})">On Enter
            </button>
            <button
              :class="{ selected: !onEnterAnimate && onExitAnimate }"
              @click.stop="updatePageAnimation({style: currentAnimation.style, onEnter: false, onExit: true})">On Exit
            </button>
          </div>
          <div class="mt-30">
            <h5 class="clr-3F3F3F fs-12">Scale Speed</h5>
            <input
              id="range-slider__range4"
              v-model="speed"
              type="range"
              class="range__input"
              min="1"
              max="100"
              @click.stop
              @mouseup="updatePageAnimation({style: currentAnimation.style, onEnter: onEnterAnimate, onExit: onExitAnimate})"
            >
          </div>
          <div class="mt-20">
            <h5 class="clr-3F3F3F fs-12">Scale</h5>
            <button
              :class="{selected: currentAnimation.style == 'pageZoomIn'}"
              @click.stop="updatePageAnimation({style: 'pageZoomIn', onEnter: onEnterAnimate, onExit: onExitAnimate})">In
            </button>
            <button
              :class="{selected: currentAnimation.style == 'pageZoomOut'}"
              @click.stop="updatePageAnimation({style: 'pageZoomOut', onEnter: onEnterAnimate, onExit: onExitAnimate})">Out
            </button>
          </div>
        </div>
        <div
          v-if="currentAnimation.style !== 'pageAnimationNone'"
          class="animation-row remove-container">
          <button
            v-if="activeObject"
            class="remove_animation"
            @click.stop="removePageTransition">
            Remove Animation
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import ElementAnimationMixin from '@/mixins/ElementAnimation';
import PanelHeading from '@/components/PanelHeading/PanelHeading';

export default {
  name:       'AnimationPanel',
  components: {
    'panel-heading': PanelHeading,
  },
  mixins: [ElementAnimationMixin],
  props:  {
    product:      Object,
    activePage:   Number,
    activeObject: Object,
  },
  data() {
    return {
      activeSubPanel: '',
      direction:      '',
      speed:          50,
      distance:       50,
      onEnterAnimate: false,
      onExitAnimate:  false,
      bothAnimate:    false,
    };
  },
  computed: {
    currentAnimation() {
      return this.product.pages[this.activePage].animation;
    },
    togglePageAnimation() {
      return this.$store.getters['activeProduct/getDisplayAnimationPanel'];
    },
    isActiveObjectHasAnimation() {
      // console.log('isActiveObjectHasAnimation');
      // console.log(this.activeObject);
      // console.log(this.activeObject.animation);
      // console.log(this.activeObject.animation.style);
      // console.log(this.activeObject.animation.style.length);
      // console.log(this.activeObject.animation.style.length > 0);
      if (this.activeObject && this.activeObject.animation != undefined && this.activeObject.animation.style && this.activeObject.animation.style.length > 0) {
        return true;
      }
      return false;
    },
    isActiveObjectIsText() {
      console.log('isActiveObjectIsText');
      console.log(!!((this.activeObject && this.activeObject.type === 'text')));
      return !!((this.activeObject && this.activeObject.type === 'text'));
    },
    isActiveObjectIsImage() {
      return !!((this.activeObject && this.activeObject.type === 'image' && this.activeObject.ImageType != 'SVGImage' && this.activeObject.ImageType != 'FDICLogo' && this.activeObject.ImageType != 'WhiteboxLogo' && this.activeObject.ImageType != 'FDICText'));
    },
    getPageAnimationIndex() {
      return this.$store.getters['activeProduct/getPageAnimationIndex'];
    },
    selectedTransition() {
      console.log(this.getPageAnimationIndex);
      if (this.product.transitions && this.product.transitions[this.getPageAnimationIndex]) {
        this.speed = this.product.transitions[this.getPageAnimationIndex].speed;
        return this.product.transitions[this.getPageAnimationIndex];
      }
      return {};
    },
    currentObjAnimeStyle() {
      if (this.activeObject) {
        const animation = { ...this.activeObject.animation };
        console.log(animation);
        this.speed          = animation.speed;
        this.distance       = animation.distance;
        this.onEnterAnimate = animation.onEnter;
        this.onExitAnimate  = animation.onExit;
        if (animation.style && animation.style.includes('fade')) {
          this.activeSubPanel = 'fade';
        } else if (animation.style && animation.style.includes('zoom')) {
          this.activeSubPanel = 'zoom';
        } else if (animation.style && animation.style.includes('stomp')) {
          this.activeSubPanel = 'stomp';
        } else if (animation.style && animation.style.includes('pan')) {
          this.activeSubPanel = 'pan';
        } else if (animation.style && animation.style.includes('photoZom')) {
          this.activeSubPanel = 'photoZom';
        } else if (animation.style && animation.style.includes('photoRise')) {
          this.activeSubPanel = 'photoRise';
        } else if (animation.style && animation.style.includes('typewriter')) {
          this.activeSubPanel = 'typewriter';
        } else if (animation.style && animation.style.includes('burst')) {
          this.activeSubPanel = 'burst';
        } else {
          this.activeSubPanel = '';
        }
        return animation.style;
      }
      return '';
    },
  },
  mounted() {
    this.onEnterAnimate = this.product.pages[this.activePage].animation.onEnter;
    this.onExitAnimate  = this.product.pages[this.activePage].animation.onExit;
    this.speed          = this.product.pages[this.activePage].animation.speed;
    if (this.activeObject) {
      this.onEnterAnimate = this.activeObject.animation && this.activeObject.animation.onEnter ? this.activeObject.animation.onEnter : false;
      this.onExitAnimate  = this.activeObject.animation && this.activeObject.animation.onExit ? this.activeObject.animation.onExit : false;
      this.speed          = this.activeObject.animation && this.activeObject.animation.speed ? this.activeObject.animation.speed : 1;
    }
  },
  methods: {
    removePageTransition() {
      EventBus.$emit(ApplicationEventTypes.TransitionEvents.ADD_TRANSITION, 'pageAnimationNone', this.activePage, 50);
    },
    showPageAnimationSubPanel({ style }) {
      const pageIndex             = this.$store.getters['activeProduct/getPageAnimationIndex'];
      const firstScreenStartTime  = this.calculateFirstScreenStartTime(pageIndex);
      const secondScreenStartTime = this.calculateSecondScreenTime(pageIndex);
      const firstScreenDuration   = this.calculateScreenDuration(pageIndex);
      const secondScreenDuration  = this.calculateScreenDuration(pageIndex + 1);
      const transition            = [
        {
          name:  style,
          speed: this.speed,
          firstScreenStartTime,
          firstScreenDuration,
          secondScreenStartTime,
          secondScreenDuration,
        }];
      if (style != '') {
        this.updatePageAnimation({ style });
        this.updateTransition(transition);
        setTimeout(() => { EventBus.$emit(ApplicationEventTypes.TransitionEvents.PREVIEW_TRANSITION, transition); });
      }
    },
    calculateFirstScreenStartTime(index) {
      let startTime = 0;
      for (let i = 0; i < index; i++) {
        startTime += parseFloat(this.product.pages[i].animation.duration);
      }
      return startTime;
    },
    calculateSecondScreenTime(index) {
      let startTime = 0;
      for (let i = 0; i <= index; i++) {
        startTime += parseFloat(this.product.pages[i].animation.duration);
      }
      return startTime;
    },
    calculateScreenDuration(index) {
      return parseFloat(this.product.pages[index].animation.duration);
    },
    updateTransition(transition) {
      EventBus.$emit(ApplicationEventTypes.TransitionEvents.UPDATE_TRANSITION, transition);
    },
    updatePageAnimation({ style, onEnter, onExit }) {
      const speed         = this.speed;
      this.onEnterAnimate = onEnter;
      this.onExitAnimate  = onExit;
      const index         = this.activePage;
      EventBus.$emit(ApplicationEventTypes.TransitionEvents.ADD_TRANSITION, style, index, speed);
      this.emitUndoRedoRequest('Apply Transition');
      setTimeout(() => {
        // this.pageTransition({
        //   speed, style, onEnter, onExit,
        // });
      }, 50);
    },
    handleAnimation({ style, onEnter, onExit }) {
      const { speed }     = this;
      const { distance }  = this;
      const duration      = this.product.pages[this.activePage].animation.duration;
      this.onEnterAnimate = onEnter;
      this.onExitAnimate  = onExit;
      console.log('handleAnimation this.distance');
      console.log(distance);
      this.animateElement({
        speed, style, onEnter, onExit, duration, distance,
      });
      EventBus.$emit(ApplicationEventTypes.AnimationEvent.SET_ELEMENT_ANIMATION, {
        animation: {
          speed,
          style,
          onEnter,
          onExit,
          distance,
        },
        isAnimated: true,
      });
      this.emitUndoRedoRequest('apply Animation');
    },
    showSubpanel(styleName, { style, onEnter, onExit }) {
      this.speed          = 50;
      this.distance       = 50;
      this.onEnterAnimate = onEnter;
      this.onExitAnimate  = onExit;
      this.activeSubPanel = styleName;
      console.log('showSubpanel this.distance');
      console.log(this.distance);
      if (style != '') {
        this.handleAnimation({
          speed:    this.speed, style, onEnter, onExit, distance: this.distance,
        });
      }
    },
    removeAnimation() {
      const style    = '';
      const speed    = 50;
      const distance = 50;
      const onEnter  = false;
      const onExit   = false;
      EventBus.$emit(ApplicationEventTypes.AnimationEvent.SET_ELEMENT_ANIMATION, {
        animation: {
          speed,
          style,
          onEnter,
          onExit,
          distance,
        },
        isAnimated: false,
      });
    },
    emitUndoRedoRequest(data) {
      EventBus.$emit('addIntoPageWiseUndoRedoArray', data);
    },
  },
};
</script>

<style scoped lang="scss">
.animation-panel {
  .active {
    position: relative;

    &::after {
      content: "";
      width: 50px;
      height: 25px;
      // background-color: #F2F2F2;
      position: absolute;
      bottom: -25px;
      transform: translate(-50%, 0%);
      left: 50%;

      background-repeat: no-repeat;
      background-position: top center;
    }
    &.none{
      &::after {
        content: none;
      }
    }
  }
}

.animation-row {
  display: flex;
  justify-content: flex-start;
  text-align: center;
  padding-left: 15px;
  padding-right: 15px;

  img {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06),
    0px 0px 1px rgba(0, 0, 0, 0.04);
    border-radius: 6px;
    cursor: pointer;
  }

  h5 {
    font-size: 11px;
    margin-top: 4px;
  }
}

//Range Input
.range__input {
  appearance: none;
  width: calc(100% - (73px));
  height: 4px;
  border-radius: 5px;
  background: #d6d6d6;
  outline: none;
  padding: 0;
  margin: 0;
}

/*Range black ⚫ thumb*/
.range__input::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background: #ffffff;
  border: 2px solid #3bb0fa;
  cursor: pointer;
  transition: background 0.15s ease-in-out;
}

/*On hover change colour of black thumb into green 🟢 and scale size*/
.range__input::-webkit-slider-thumb:hover {
  transform: scale(1.1);
  background: #1abc9c;
}

.range__input:active::-webkit-slider-thumb {
  transform: scale(1.1);
  background: #1abc9c;
}

.wrapper {
  position: absolute;
  display: flex;
}

.container-trimming {
  display: flex;
  position: relative;
}

.range_type {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: calc(100% - (8px));
  height: 5px;
  outline: none;
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  cursor: ew-resize;
  position: absolute;

  &:focus {
    border: none;
  }
}

.range_type::-webkit-slider-thumb {
  -webkit-appearance: none;
  pointer-events: auto;
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background: #ffffff;
  border: 2px solid #3bb0fa;
  cursor: pointer;
  transition: background 0.15s ease-in-out;

}

input[type="range"]:active::-webkit-slider-thumb {
  background-color: #3bb0fa;
}
.line-for-slider{
  position: relative;
  background: #3bb0fa;
  width: calc(100% - (8px));
  border-radius: 10px;
  height: 5px;
}
.start-slider{
  position: absolute;
  background: white;
  border-radius: 10px;
  height: 5px;
  left: 0;
}
.end-slider{
  position: absolute;
  background: white;
  border-radius: 10px;
  height: 5px;
  right: 0;
}
</style>
